import { render, staticRenderFns } from "./UITrendingIndexWidget.vue?vue&type=template&id=224cbef4"
import script from "./UITrendingIndexWidget.vue?vue&type=script&lang=js"
export * from "./UITrendingIndexWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ChangePercent: require('/skade-pwa/components/ui/atom/ChangePercent.vue').default})
